import { render } from "./Equipment.vue?vue&type=template&id=1c8a8776&ts=true"
import script from "./Equipment.vue?vue&type=script&lang=ts"
export * from "./Equipment.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__